<div class="modal-container">
  <h2 class="modal-title">Price Change Alert</h2>
  <p class="modal-message">
    There is some price change in the truck. Do you want to continue?
  </p>

  <div class="modal-actions">
    <button mat-button class="no-btn" (click)="onCancel()">No</button>
    <button mat-button color="primary" class="yes-btn" (click)="onConfirm()">
      Yes
    </button>
  </div>
</div>
